import { dataFilmSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFilmSolid = /*#__PURE__*/createIcon(dataFilmSolid)
export default IconFilmSolid
